import { PatientKind } from "common/types";

import { ProductLineSearchFilters, SelectedCategoryProductLineFilters } from "../types";
import SearchFilterTags from "./SearchFilterTags";

type CategoryProductLineSearchFilterTagsProps = {
  options: ProductLineSearchFilters;
  value: SelectedCategoryProductLineFilters;
  onChange: (value: SelectedCategoryProductLineFilters) => void;
};

const CategoryProductLineSearchFilterTags = ({
  options,
  value,
  onChange,
}: CategoryProductLineSearchFilterTagsProps) => {
  return (
    <>
      <SearchFilterTags<PatientKind>
        options={options.species}
        value={value.species}
        onChange={(species) =>
          onChange({
            ...value,
            species,
          })
        }
      />
      <SearchFilterTags
        options={options.manufacturers}
        value={value.manufacturer_ids}
        onChange={(manufacturer_ids) => onChange({ ...value, manufacturer_ids })}
      />
      <SearchFilterTags<boolean>
        options={options.prescription_required}
        value={value.prescription_required}
        onChange={(prescription_required) => onChange({ ...value, prescription_required })}
      />
    </>
  );
};

export default CategoryProductLineSearchFilterTags;
